import React from 'react'
import {Row, Col} from 'react-flexbox-grid'

export const NotFound = () => {
   console.log('render', 'dashboard/network/NotFound', window.location.hash)

   return (
      <Row>
         <Col xs={12}>
            <h1>No such network</h1>

            <p>
               The network your looking for was not found, are you sure the
               network exists and that you have access?
            </p>
         </Col>
      </Row>
   )
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/NotFound.jsx